import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";

import UserList from "../../components/UserList";
import { getSearchUsers } from "../../services";

import styles from "./index.module.less";

export default function SearchUserList({
  query,
  empty,
  searchResult,
  cardType,
}) {
  const pageRef = useRef(searchResult ? 2 : 1);
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(searchResult || []);
  const [busy, setBusy] = useState(false);

  const { q } = query;

  const initRef = useRef(!searchResult);

  const queryAction = useMemo(() => {
    // 服务端渲染时，不做初始化的一些操作
    if (initRef.current) {
      pageRef.current = 1;
      setHasMore(true);
      setDataSource([]);
    } else {
      initRef.current = true;
    }

    return async () => {
      if (!q) {
        return;
      }

      // 设置如果超过30秒，显示服务器繁忙，请稍等片刻...
      const timer = setTimeout(() => {
        setBusy(true);
      }, 10000);
      const result = await getSearchUsers({
        q,
        per_page: 20,
        sort: "all2",
        page: pageRef.current,
        hide_other_count: 1,
      });
      // 如果结果返回有问题直接设置繁忙，如果没问题就清楚定时器
      if (result?.err) {
        setBusy(true);
      } else {
        clearTimeout(timer);
        setBusy(false);
      }

      const users = result?.users || [];

      if (users.length <= 0) {
        setHasMore(false);
      }

      setDataSource((dataSource) => dataSource.concat(users));
    };
  }, [q]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  const onLoadMore = useCallback(() => {
    pageRef.current = ++pageRef.current;
    queryAction();
  }, [queryAction]);

  return (
    <div className={styles.user}>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <UserList
            type={cardType}
            loadingContent={
              busy ? (
                <div className={styles.busy}>服务器繁忙，请稍等片刻...</div>
              ) : null
            }
            dataSource={dataSource}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        </Then>
        <Else>{empty}</Else>
      </If>
    </div>
  );
}
